import { __decorate } from "tslib";
import TransactionsTable from '@/components/TransactionsTable.vue';
import { Component } from "vue-property-decorator";
import SimpleTable from "@/components/SimpleTable.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import ModalMixin from "@/mixins/modal-mixin";
import InvoiceSummaryPrint from "@/Pages/People/Customer/InvoiceSummaryPrint.vue";
import CombinedInvoicePrintModal from "@/Pages/People/Customer/CombinedInvoicePrintModal.vue";
let Transactions = class Transactions extends ModalMixin {
    fetchInvoices;
    findInvoicesStore;
    invoiceMode = false;
    selected = []; // selected ids
    get invoices() {
        return this.findInvoicesStore(this.params).data;
    }
    get params() {
        return {
            query: {
                customerId: this.$route.params.id,
                status: { $ne: 'cancelled' }
            }
        };
    }
    get columns() {
        return [
            {
                label: 'Date',
                name: 'createdAt',
                date_format: 'YYYY-MM-DD'
            },
            {
                label: 'Paid amount',
                name: 'paidTotal',
                field: (item) => {
                    return Math.abs(item.totalPaid);
                },
                money: true
            },
            {
                label: 'Amount',
                name: 'paidAmount',
                field: (item) => {
                    return item.totalPrice;
                },
                money: true
            },
            {
                label: 'Status',
                name: 'status',
                field: (item) => {
                    if (item.totalPaid < Math.abs(item.totalPrice))
                        return `<span class="badge badge-warning badge-pill">${this.$t('Paid partially')}</span>`;
                    return `<span class="badge badge-success badge-pill">${this.$t('Paid')}</span>`;
                }
            }
        ];
    }
    toggleMode() {
        this.invoiceMode = !this.invoiceMode;
        if (this.invoiceMode) {
            this.fetchInvoices(this.params);
        }
        else {
            if (this.selected.length === 0)
                return this.invoiceMode = false;
            const { Invoice } = this.$FeathersVuex;
            new Invoice({ _id: 'temp', model: { selected: this.selected, customerId: this.$route.params.id } });
            this.openModal({ id: 'InvoiceSummaryPrint' });
            this.selected = [];
        }
    }
    printCombined() {
        const { Invoice } = this.$FeathersVuex;
        new Invoice({ _id: 'temp', model: { selected: this.selected, customerId: this.$route.params.id } });
        this.openModal({ id: 'CombinedInvoicePrint' });
        this.selected = [];
    }
};
Transactions = __decorate([
    Component({
        components: { InvoiceSummaryPrint, SimpleTable, TransactionsTable, CombinedInvoicePrintModal },
        methods: {
            ...mapActions('invoices', { fetchInvoices: 'find' })
        },
        computed: {
            ...mapGetters('invoices', { findInvoicesStore: 'find' }),
            ...mapState('invoices', { isDataLoading: 'isFindPending' })
        }
    })
], Transactions);
export default Transactions;
